import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {createDailyLog} from "../../../actions/dailyLog";
import {DailyLogForm} from "./DailyLogForm";
import {currentEffectiveUserId} from "../../../reducers/ui";

const DailyLogNew = props => {
  const { projectid, onSubmit, onCancel, userid } = props;
  return <Card title='Daily Log Details' className={'edit-view'}>
    <DailyLogForm projectid={projectid} onCancel={onCancel} onSubmit={onSubmit} userid={userid}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => ({ projectid: props.match.params.id, userid: currentEffectiveUserId(state) }),
    (dispatch, props) => ({
      onSubmit: (dailyLog) => {
        return dispatch(createDailyLog(props.match.params.id, dailyLog, (dailyLogId) => props.history.push(`/projects/${props.match.params.id}/daily-logs/${dailyLogId}`)));
      },
      onCancel: () => props.history.goBack()
    })
  )
)(DailyLogNew);



// WEBPACK FOOTER //
// ./src/components/Projects/DailyLogs/DailyLogNew.js